const STORAGE_KEY = 'run2sale_waitlist';

export interface WaitlistEntry {
  type: 'shopper' | 'merchant';
  email: string;
  storeName?: string;
  submittedAt: string;
}

export function getWaitlistEntry(): WaitlistEntry | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as WaitlistEntry;
  } catch {
    return null;
  }
}

export function saveWaitlistEntry(entry: WaitlistEntry): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
}

export function hasSubmitted(): boolean {
  return getWaitlistEntry() !== null;
}
